<h2 mat-dialog-title>Set next invoice date</h2>
<mat-dialog-content>
  <div class="entity-form">
    <mat-form-field>
      <mat-label> Date </mat-label>
      <input [formField]="form.date" matInput [matDatepicker]="picker">
      <mat-hint>DD/MM/YYYY</mat-hint>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button matMiniFab matTooltip="Save next invoice date" (click)="save()" [disabled]="!form().valid() || pending()">
    <mat-icon>save</mat-icon>
  </button>
</mat-dialog-actions>
@if (pending()) {
<mat-progress-bar mode="indeterminate" />
}
